import React, {useEffect, useMemo, useRef, useState} from 'react';
import FieldInput from "../../../../../components/filed/example/FieldInput";
import FieldText from "../../../../../components/filed/example/FieldText";
import FieldUser from "../../../../../components/filed/example/FieldUser";
import FieldDate from "../../../../../components/filed/example/FieldDate";
import {createFiled, reorderFields} from "../../../../../api/field/FieldService";
import {handleActiveError, handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import {getGroupSelectListField} from "../../../../../api/field/CustomCodeService";
import CustomSelectBox from "../../../../../components/select/CustomSelectBox";
import FieldSelect from "../../../../../components/filed/example/FieldSelect";
import SimmsInput from "../../../../../components/input/SimmsInput";
import {DragDropContext, Draggable, Droppable} from '@hello-pangea/dnd';
import FieldFormatDisplay from "../../../../../components/filed/example/FieldFormatDisplay";
import "../../shared/groupFieldEditor.css";

const FIELD_FORMAT_OPTIONS = [
    {id: "INPUT", label: "단문"},
    {id: "TEXT", label: "장문"},
    {id: "DATE", label: "날짜"},
    {id: "USER", label: "사용자"},
    {id: "SELECT", label: "선택옵션"},
];

function FieldSet({code, fields, setFlag, managed = false, embedded = false, hideHeader = false}) {

    const [groupSelect, setGroupSelect] = useState([]);
    const filtered = useMemo(() => (fields || []).filter(each => each.code.id === code.id), [fields, code?.id]);
    const [items, setItems] = useState([]);
    const containerRef = useRef(null);

    const options = [
        {id: null, name: "선택"},
        {id: "INPUT", name: "INPUT"},
        {id: "TEXT", name: "TEXT"},
        {id: "DATE", name: "DATE"},
        {id: "USER", name: "USER"},
        {id: "SELECT", name: "SELECT"},
    ];
    async function getGroups() {
        return  await getGroupSelectListField();
    }

    const [data, setData] = useState({code: {id: code.id}, type: "INPUT"});

    useEffect(() => {
        setData({code: {id: code.id}, type: "INPUT"});
    }, [code?.id]);


    useEffect(() => {
        getGroups().then(r =>
            setGroupSelect([  {id: null, name:"선택"},...r.data]))
    }, [data])

    async function goInsert(){
        if (!data.type) {
            alert("형식 선택은 필수입니다.");
            return;
        }
        if(!data.title){
            alert('필드명을 입력하세요.')
            return;
        }
        if(data.type=='SELECT' && !data.entity){
            alert('코드 종류를 선택하세요')
            return;
        }
        data.code.id = code.id
        const _ = await createFiled(data);

        if (_.status === 200) {
            handleActiveToast({
                description: "", message: "등록 되었습니다.", labelListener: () => {
                }
            })
        }else if(_.status ===201 ||(_.status === 202)){
            handleActiveError({message: _.data.title, description: _.data.reason});
        }else  {
            console.log(_)
            handleActiveToast({
                description: "알 수 없는 에러.", message: " 등록할 수 없습니다..", labelListener: () => {
                }
            })
        }

        setFlag(true);
        setData({code: {id: code.id}, type: "INPUT"});

    }

    useEffect(() => {
        const sorted = (filtered || [])
            .slice()
            .sort((a,b) => (a.orders ?? 9999) - (b.orders ?? 9999));
        setItems(sorted);
    }, [filtered]);

    const renderRowCells = (each, dragHandleProps) => {
        if (each.type === 'INPUT')  return <FieldInput each={each} setFlag={setFlag} dragHandleProps={dragHandleProps} />;
        if (each.type === 'TEXT')   return <FieldText  each={each} setFlag={setFlag} dragHandleProps={dragHandleProps} />;
        if (each.type === 'USER')   return <FieldUser  each={each} setFlag={setFlag} dragHandleProps={dragHandleProps} />;
        if (each.type === 'DATE')   return <FieldDate  each={each} setFlag={setFlag} dragHandleProps={dragHandleProps} />;
        if (each.type === 'SELECT') return <FieldSelect each={each} options={groupSelect} dragHandleProps={dragHandleProps} />;
        return null;
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const handleDragEnd = async (result) => {
        const { source, destination } = result;
        if (!destination) return;
        if (source.index === destination.index) return;

        const reordered = reorder(items, source.index, destination.index)
            .map((it, idx) => ({ ...it, orders: idx + 1 }));

        const prev = items;
        setItems(reordered);

        try {
            const res = await reorderFields({
                code: code,
                orderList: reordered,
            });

            if (res.status === 200 || res.status === 204) {
                setFlag(true);
                handleActiveToast({ message: '필드 순서가 저장되었습니다.' });
            } else {
                setItems(prev);
                handleActiveError({ message: '순서 저장 실패', description: res.data?.message });
            }
        } catch (err) {
            setItems(prev);
            handleActiveError({ message: '순서 저장 실패', description: err.message });
        }
    };

    const getRowStyle = (style, snapshot, containerRef) => {
        if (!snapshot.isDragging) {
            return style || {};
        }

        const container = containerRef.current;
        const containerWidth = container
            ? container.getBoundingClientRect().width
            : style?.width;

        return {
            ...style,
            width: containerWidth,
            boxSizing: 'border-box',
            display: 'table-row',
        };
    };

    const fieldListSection = (
        <div className={managed ? "group-field-editor__list" : "fieldCode-info"} ref={containerRef}>
            {items.length === 0 && managed ? (
                <p className="group-field-editor__empty">등록된 필드가 없습니다. 위에서 필드를 추가하세요.</p>
            ) : (
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable
                        droppableId={`fields-${code.id}`}
                        direction="vertical"
                        renderClone={(provided, snapshot, rubric) => {
                            const each = items[rubric.source.index];
                            const container = containerRef.current;
                            const containerWidth = container
                                ? container.getBoundingClientRect().width
                                : 'auto';

                            return (
                                <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    className="dragging-row"
                                    style={{
                                        ...provided.draggableProps.style,
                                        display: 'table',
                                        width: containerWidth,
                                        maxWidth: '100%',
                                        boxSizing: 'border-box',
                                        zIndex: 5000,
                                        background: '#fff',
                                    }}
                                >
                                    {renderRowCells(each, provided.dragHandleProps)}
                                </tr>
                            );
                        }}
                    >
                        {(dropProvided) => (
                            <table className="w-full create-table">
                                <tbody
                                    ref={dropProvided.innerRef}
                                    {...dropProvided.droppableProps}
                                >
                                {items.map((each, index) => (
                                    <Draggable
                                        key={each.id}
                                        draggableId={String(each.id)}
                                        index={index}
                                    >
                                        {(dragProvided, snapshot) => (
                                            <tr
                                                ref={dragProvided.innerRef}
                                                {...dragProvided.draggableProps}
                                                className={snapshot.isDragging ? 'invisible-row' : ''}
                                            >
                                                {renderRowCells(each, dragProvided.dragHandleProps)}
                                            </tr>
                                        )}
                                    </Draggable>
                                ))}
                                {dropProvided.placeholder}
                                </tbody>
                            </table>
                        )}
                    </Droppable>
                </DragDropContext>
            )}
        </div>
    );

    if (managed) {
        const content = (
            <>
                {!hideHeader && (
                    <span className="code-editor__meta">항목 설정</span>
                )}

                <div className="group-field-editor__form">
                    <div className="group-field-editor__form-row group-field-editor__form-row--format">
                        <span className="group-field-editor__inline-label">형식</span>
                        <div className="group-field-editor__format-picker" role="radiogroup" aria-label="필드 형식">
                            {FIELD_FORMAT_OPTIONS.map((option) => {
                                const isActive = (data.type ?? "INPUT") === option.id;
                                return (
                                    <label
                                        key={option.id}
                                        className={`group-field-editor__format-option${isActive ? " is-active" : ""}`}
                                    >
                                        <input
                                            type="radio"
                                            className="group-field-editor__format-option-input"
                                            name={`group-field-format-${code.id}`}
                                            value={option.id}
                                            checked={isActive}
                                            onChange={() => setData((prev) => ({...prev, type: option.id}))}
                                        />
                                        <span className="group-field-editor__format-chip">
                                            <FieldFormatDisplay type={option.id} showLabel />
                                        </span>
                                    </label>
                                );
                            })}
                        </div>
                        {data.type === "SELECT" && (
                            <>
                                <span className="group-field-editor__inline-label">
                                    옵션 그룹
                                    <span className="required">*</span>
                                </span>
                                <select
                                    className="basic-input input-style group-field-editor__select"
                                    value={data.entity ?? ""}
                                    onChange={(e) => setData((prev) => ({
                                        ...prev,
                                        entity: e.target.value ? Number(e.target.value) : null,
                                    }))}
                                >
                                    {groupSelect.map((option) => (
                                        <option key={option.id ?? "empty"} value={option.id ?? ""}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </>
                        )}
                    </div>

                    <div className="group-field-editor__form-row group-field-editor__form-row--create">
                        <label className="group-field-editor__inline-label" htmlFor={`group-field-name-${code.id}`}>
                            필드명
                            <span className="required">*</span>
                        </label>
                        <input
                            id={`group-field-name-${code.id}`}
                            type="text"
                            className="basic-input input-style group-field-editor__name-input"
                            placeholder="필드명"
                            value={data.title ?? ""}
                            onChange={(e) => setData((prev) => ({...prev, title: e.target.value}))}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    goInsert();
                                }
                            }}
                        />
                        <button type="button" className="save-btn group-field-editor__submit-btn" onClick={goInsert}>
                            등록
                        </button>
                    </div>
                </div>

                <div className="group-field-editor__list-section">
                    <span className="code-editor__meta code-editor__meta--sub">등록된 필드</span>
                    <div className="group-field-editor__list-scroll code-manage-scroll-area">
                        {fieldListSection}
                    </div>
                </div>
            </>
        );

        if (embedded) {
            return (
                <div className="group-field-editor group-field-editor--embedded code-manage-scope">
                    {content}
                </div>
            );
        }

        return (
            <div className="code-editor code-editor--wide group-field-editor code-manage-scope">
                {content}
            </div>
        );
    }

    return (
        <div className={"flex flex-col "}>
            <p className="code-title" onClick={()=>console.log(data)}>{code.name}</p>
            <section className="section display-table">
                <p className="mb-1.5">추가할 필드</p>
                <table className="w-full create-table">
                    <tbody>
                    <tr>
                        <th className="fieldset-th">
                            <SimmsInput constraint={{required:true}} data={data.title} onChange={(v)=>setData(prevState => ({
                                ...prevState,
                                ['title']:v
                            }))} />
                        </th>
                        <td colSpan={3} className="fieldset-td">
                            <div className="inline-block mr-4">
                                <CustomSelectBox target={'type'} options={options}
                                                 setter={setData}/>
                            </div>
                            <div className={`inline-block mr-4`}>
                                {data.type == 'SELECT' &&
                                    <CustomSelectBox target={'entity'}  options={groupSelect}
                                                     setter={setData}/>
                                }
                            </div>

                            <button className="save-btn float-right mr-[5px]" onClick={goInsert}>등록
                            </button>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </section>


            <section className="section display-table">
                <p className="mb-1.5">추가된 필드</p>
                {fieldListSection}
            </section>
        </div>
    );
}

export default FieldSet;